import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ApiService, IconfirmOTP, IEcoupon } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root',
})
export class EcouponServiceService {
  // // constructor() { }
  private readonly apiService = inject(ApiService);
  private readonly loggingService = inject(LoggingService);

  //for guard
  private dataFormSignal = signal<any>(undefined);

  private readonly errorMessageSignal = signal<any>(undefined);
  private readonly refOtpSignal = signal<string>('');
  private readonly errorStatus = signal<number>(0);
  private readonly hourExpireSignal = signal<string | number>('');

  getDataFormSignal() {
    this.loggingService.log('get data form', this.dataFormSignal());
    return this.dataFormSignal;
  }
  setDataFormSignal(data: IEcoupon) {
    this.dataFormSignal.set(data);
  }
  clearDataFormSignal() {
    this.dataFormSignal.set(undefined);
  }
  setRefOtpSignal(value: any) {
    this.refOtpSignal.set(value);
  }
  getRefOtpSignal(): WritableSignal<string> {
    return this.refOtpSignal;
  }

  getErrorMessageSignal() {
    this.loggingService.log('errorMessageSignal', this.errorMessageSignal());
    return this.errorMessageSignal;
  }
  setErrorMessageSignal(value: string) {
    this.loggingService.log('errorMessageSignal', value);
    this.errorMessageSignal.set(value);
    this.loggingService.log('errorMessageSignal', this.errorMessageSignal());
  }
  clearErrorMessageSignal() {
    this.errorMessageSignal.set('');
  }

  getErrorStatusSignal() {
    return this.errorStatus;
  }

  getHourExpireSignal() {
    return this.hourExpireSignal;
  }
  setHourExpireSignal(value: string | number) {
    this.hourExpireSignal.set(value);
  }
  setErrorStatusSignal(value: number) {
    this.errorStatus.set(value);
  }
  clearErroStatusSignal() {
    this.errorStatus.set(10); //set = 10 for success
  }

  //CALL OTP
  postForm(form: IEcoupon) {
    form.brand = 'toyo';
    this.loggingService.log('Lib Service | postForm', form);
    return this.apiService.postForm(form).pipe(
      tap((res: any) => {
        if (res) {
          this.loggingService.log('tap msg|subscribe', res);
          if (res.ok == 1) {
            this.loggingService.log('otp form api', res.data.ref_no);
            this.setRefOtpSignal(res.data.ref_no);
            this.setHourExpireSignal(res.hour_expire ?? '');
            this.clearErrorMessageSignal();
          } else {
            this.loggingService.log('check error', res);
            this.loggingService.log('check error', res.error);
            this.setErrorMessageSignal('');

            // this.errorStatus.set(res.error);
            if (res.error == 3.1) {
              this.setErrorMessageSignal('ท่านได้รับสิทธิครบตามจำนวนที่กำหนดแล้ว');
            } else if (res.error == 3.2) {
              this.setErrorMessageSignal('ท่านได้รับสิทธิครบตามจำนวนที่กำหนดแล้ว');
            } else if (res.error == 3.3) {
              this.setErrorMessageSignal('หมายเลขโทรศัพท์ และ ทะเบียนรถคันนี้ไม่สามารถรับสิทธิได้ 30 วัน');
            } else if (res.error == 5) {
              this.setErrorMessageSignal('หมายเลขโทรศัพท์นี้รับสิทธิเรียบร้อยแล้ว');
            }
            // else {
            //   this.setErrorMessageSignal(res.msg);
            //   this.errorStatus.set(res.error);
            // }
          }
        }
      })
    );
  }

  // getProvince() {
  //   return this.apiService.getProvince();
  // }
  // // sendOTP(form: IEcoupon) {
  // //   this.loggingService.log('CoreService | sendOTP', form.mobile);
  // // }
  confirmOTP(value: IconfirmOTP) {
    this.loggingService.log('CoreService | confirmOTP', value);
    return this.apiService.confirmOTP(value).pipe(
      tap((res: any) => {
        if (res) {
          this.loggingService.log('tap confirmOTP|subscribe', res);
          if (res.ok == 1) {
            this.clearErroStatusSignal();
            this.loggingService.log('confirmOTP form api', res);
            this.setRefOtpSignal(res.data?.ref_no ?? '');
            this.clearErrorMessageSignal();
          } else {
            this.loggingService.log('check error', res);
            this.loggingService.log('check error', res.error);
            this.errorStatus.set(res.error);
            if (res.error == 4) {
              this.setErrorMessageSignal('รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง');
              // this.setErrorStatusSignal(res.error);
            } else {
              this.clearErrorMessageSignal();
            }
          }
        }
      })
    );
  }
  getDetailCampaign(id: string) {
    const brand = 'toyo';
    this.loggingService.log('service |getDetailCampaign', id);
    return this.apiService.getDetailCampaign(id, brand).pipe(
      tap((res: any) => {
        if (res) {
          this.loggingService.log('tap |getDetailCampaign', res);
          if (res.ok == 1) {
            this.loggingService.log('getDetailCampaign', res);
            if (res.error) {
              this.errorMessageSignal.set(res.msg);
              this.errorStatus.set(res.error);
            } else if (res.error == 0) {
              this.errorStatus.set(res.error);
            } else {
              this.clearErroStatusSignal();
            }
          }
        }
      })
    );
  }
  getCheckCampaignFull(id: string) {
    this.loggingService.log('tap |getCheckCampaign', id);
    return this.apiService.getCheckCampaignFull(id).pipe(
      tap((res: any) => {
        if (res) {
          this.loggingService.log('tap |getCheckCampaignFull', res);
          if (res.ok == 1) {
            this.loggingService.log('getCheckCampaignFull', res);
            if (res.data.full === 1) {
              this.errorStatus.set(1);
            } else {
              this.clearErroStatusSignal();
            }
          }
        } else {
          this.errorStatus.set(0);
          this.errorMessageSignal.set(res.msg);
        }
      })
    );
  }
  getCheckCampaignExpire(id: string) {
    this.loggingService.log('tap |getCheckCampaign', id);
    return this.apiService.getCheckCampaignExpire(id).pipe(
      tap((res: any) => {
        if (res) {
          this.loggingService.log('tap |getCheckCampaignExpire', res);
          if (res.ok == 1) {
            this.loggingService.log('getCheckCampaignExpire', res);
            if (res.data.expire === 1) {
              this.errorStatus.set(2);
            } else {
              this.clearErroStatusSignal();
            }
          }
        }
      })
    );
  }
}
